import { CheckCircle2, XCircle } from "lucide-react";
import type { DraftClauseLibraryToolOutput } from "./types";

type Props = {
  mode: "create" | "update";
  output: DraftClauseLibraryToolOutput;
  errorText?: string;
};

export function DraftClauseLibraryResultCard({ mode, output, errorText }: Props) {
  const failed = errorText != null || output.success === false;
  const alt = output.draftClauseAlternative;

  if (failed) {
    return (
      <div className="flex gap-3 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 dark:border-red-400/25">
        <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-500 dark:text-red-300" />
        <div>
          <p className="text-sm font-medium text-red-800 dark:text-red-200">
            {mode === "create" ? "Could not save clause variant" : "Could not update clause variant"}
          </p>
          <p className="mt-1 text-sm text-red-700/90 dark:text-red-200/80">
            {errorText ?? output.error ?? "Unknown error"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-3 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 dark:border-emerald-400/25">
      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600 dark:text-emerald-300" />
      <div className="min-w-0 space-y-1">
        <p className="text-sm font-medium text-emerald-900 dark:text-emerald-100">
          {mode === "create" ? "Clause variant saved" : "Clause variant updated"}
        </p>
        {alt ? (
          <p className="text-sm text-emerald-800/90 dark:text-emerald-100/85">
            Section <span className="font-medium">{alt.section_key ?? "—"}</span>
            {alt.clause_category ? (
              <>
                {" "}
                · <span className="font-medium">{alt.clause_category}</span>
              </>
            ) : null}
          </p>
        ) : null}
      </div>
    </div>
  );
}
